import React from 'react';
import { Form, RadioButton } from 'fw/forms';
import { Col, FormGroup, } from 'react-bootstrap';

class ReviewPanel extends React.Component {
    onChange = (form) => {
        this.setState(() => {
            return {
                form
            }
        }, () => this.props.onChange(form));
    }

    render() {
        var form = {
            isReviewCompleted: this.props.reviewStatus && this.props.canComplete
        };

        var completeLabel = this.props.stepName + " Complete";
        var incompleteLabel = "Incomplete " + this.props.stepName;
        return (
            <React.Fragment>
                <hr />
                <Form
                    onChange={this.onChange}
                    values={form}>
                    <Col md={6}>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <RadioButton
                                name="isReviewCompleted"
                                option={false}
                                label={incompleteLabel}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <RadioButton
                                name="isReviewCompleted"
                                option={true}
                                label={completeLabel}
                                disabled={!this.props.canComplete}
                            />
                        </FormGroup>
                    </Col>
                </Form>
            </React.Fragment>
        );
    }
}

export default ReviewPanel;

// Default properties
ReviewPanel.defaultProps = {
    canComplete: true,
    reviewStatus: false,
    stepName: "",
    onChange: (form) => { }
}


// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/ReviewPanel.js